import { z } from 'zod';

export const AUTONOMY_ACTION_FAMILIES = ['internal_reminder', 'vendor_followup'] as const;
export const CreateAuthorityPolicyRequest = z.object({
  policy_key: z
    .string()
    .regex(/^[a-z0-9_]+$/)
    .max(80),
  action_family: z.enum(AUTONOMY_ACTION_FAMILIES),
  resource_scope: z
    .string()
    .regex(/^[a-z0-9_*]+$/)
    .max(120),
  subject_user_id: z.string().max(40).optional(),
  max_actions_per_day: z.number().int().min(1).max(50),
  max_spend_minor: z.literal(0),
  working_hour_start: z.number().int().min(0).max(23),
  working_hour_end: z.number().int().min(1).max(24),
  timezone: z.string().min(1).max(80),
  expires_at: z.string().datetime({ offset: true }),
});
export const EvaluateAuthorityRequest = z.object({
  policy_id: z.string().max(40),
  action_family: z.enum(AUTONOMY_ACTION_FAMILIES),
  resource: z.string().min(1).max(120),
  subject_user_id: z.string().max(40).optional(),
  risk_class: z.enum(['low', 'moderate', 'high', 'prohibited']),
  reversible: z.boolean(),
  spend_minor: z.number().int().min(0),
  proposed_at: z.string().datetime({ offset: true }),
});
export const RevokeAuthorityPolicyRequest = z.object({ reason: z.string().min(1).max(500) });
export type CreateAuthorityPolicyInput = z.infer<typeof CreateAuthorityPolicyRequest>;
export type EvaluateAuthorityInput = z.infer<typeof EvaluateAuthorityRequest>;

export const CreateAutonomousActionRequest = z.object({
  evaluation_id: z.string().max(40),
  idempotency_key: z.string().min(8).max(120),
  payload: z.object({
    target: z.string().min(1).max(120),
    message: z.string().min(1).max(500),
  }),
});
export const AutonomousActionControlRequest = z.object({
  control: z.enum(['override', 'compensate', 'incident']),
  reason: z.string().min(1).max(1000),
});
export type CreateAutonomousActionInput = z.infer<typeof CreateAutonomousActionRequest>;
export type AutonomousActionControlInput = z.infer<typeof AutonomousActionControlRequest>;
